import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import {
  getApprovedAndVoidTravels,
  voidTravels,
} from "../../../../api/travelApprovalApi";
import { getSignedAttachmentUrl } from "../../../../api/attachApi";
import TravelAuthorizationVoidForm from "../../../forms/Claim/Travel/TravelAuthorizationVoidForm";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

export default function TravelAuthorizationVoidPage({ history }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [travelTrans, setTravelTrans] = useState([]);
  const [selectedTravelTrans, setSelectedTravelTrans] = useState([]);
  const [currentYear, setCurrentYear] = useState(dayjs().year());
  const [pagination, setPagination] = useState({
    current: 1,
    minIndex: 0,
    maxIndex: 100,
    pageSize: 100,
  });

  useEffect(getTravelTrans, [currentYear]);

  function getTravelTrans() {
    setIsLoading(true);
    getApprovedAndVoidTravels(currentYear)
      .then((value) => {
        // reset pagination
        resetPagination();

        setTravelTrans(value ? value : []);
        setSelectedTravelTrans([]);
        setIsLoading(false);
      })
      .catch((error) => {
        showErrorMessage(t("general.fail_to_load_record"), error);
      });
  }

  function resetPagination() {
    setPagination({
      current: 1,
      minIndex: 0,
      maxIndex: 100,
      pageSize: 100,
    });
  }

  function onAddNewTravel() {
    history("/home/travelauth/travelTrans");
  }

  function voidTravelTrans(selectedTravels, reason) {
    setIsLoading(true);

    voidTravels(selectedTravels, reason)
      .then(() => {
        getTravelTrans();
        toast.success(t("general.record_voided_successfully"));
      })
      .catch((error) => {
        setIsLoading(false);
        showErrorMessage(t("general.fail_to_void_record"), error);
      });
  }

  function viewTravelTrans(travelTransKey) {
    history("/home/travelauth/travelTrans/" + travelTransKey, {
      state: { fromVoid: true },
    });
  }

  function getValidAttachments(attachments) {
    return getSignedAttachmentUrl(attachments);
  }

  function showErrorMessage(message, error) {
    let errorMsg = error.response.data.error_description
      ? error.response.data.error_description
      : error.response.data.ExceptionMessage;

    toast.error(message + (errorMsg ? errorMsg : ""));
  }

  return (
    <TravelAuthorizationVoidForm
      isLoading={isLoading}
      data={travelTrans}
      selectedItems={selectedTravelTrans}
      onAdd={onAddNewTravel}
      onView={viewTravelTrans}
      onVoided={voidTravelTrans}
      onItemSelected={setSelectedTravelTrans}
      onAttachmentClicked={getValidAttachments}
      setCurrentYear={setCurrentYear}
      pagination={pagination}
      setPagination={setPagination}
      resetPagination={resetPagination}
    />
  );
}

TravelAuthorizationVoidPage.propTypes = {
  history: PropTypes.func.isRequired,
};
